module.exports = __webpack_public_path__ + "static/partner-logo-icefire-1c2ceebf8087cf21e83a72e4327b6e67.png";